'use strict'

define ['./datesplit.scss'], () ->
  ($window) ->
    restrict: "E"
    template: require("./datesplit.jade")
    scope: {field: "=", mode: "@", index: "=", stage: "="}
    link: (scope, element, attrs) ->
      scope.months = [ "January","February","March",
        "April","May","June","July",
        "August","September","October",
        "November","December"
      ]

      scope.date = {}
      scope.warning = {}
      scope.days = [1...32]
      scope.now = new Date()

      # For edit mode by applicant, initalize data correctly
      if scope.field.value
        [year, month, day] = scope.field.value.split("-")
        scope.date.year = Number(year)
        scope.date.month = Number(month)
        scope.date.day = Number(day)

      if scope.field.required and scope.mode == 'edit'
        scope.field_label = "#{scope.field.label}<span>&nbsp;*</span>"
      else
        scope.field_label = scope.field.label

      scope.clearDate = ->
        scope.date.year = undefined
        element = $window.document.getElementsByClassName('dob_year')
        if element and element[0]
          element[0].focus()

      scope.set_month = (month) ->
        scope.date.month = month

      scope.set_day = (day) ->
        scope.date.day = day

      scope.$watch '[date.year,date.month,date.day]', ((newValue, oldValue) ->
        year = newValue[0]
        month = newValue[1]
        date = newValue[2]
        if year and month and date
          scope.field.value = "#{year}-#{month}-#{date}"
          scope.value_date = new Date(year, month, date)
          if scope.field.name == 'applicant__date_of_birth'
            yearsOld = (new Date()).getFullYear() - year
            if yearsOld < 14 or yearsOld > 100
              scope.warning.text = """Are you sure you were born in #{year} ?"""
              scope.confirm_text = """Yes, I am #{yearsOld} years old."""
              scope.warning.visible = true
              scope.warning.datesplit = true
            else
              scope.warning.visible = false
        else
          scope.value_date = undefined
          scope.field.value = ""
      ), true



// WEBPACK FOOTER //
// ./directives/freeforms/datesplit/datesplit.coffee